import React from 'react';
import { useParams } from 'react-router-dom';

// React Router keeps ONE component instance alive when only a route param changes (customers/1 →
// customers/2), so every useState seeded from the loaded record — the Edit form, the Collect and
// Renew panels — keeps the PREVIOUS record's values while `customer` switches underneath it. On
// the customer page that meant searching for another customer mid-edit showed the first customer's
// details on the second one, and pressing Save wrote them onto it. Keying the subtree on the param
// makes each record start from a clean page.
export default function RemountOnRouteParam({ param, children }) {
  const params = useParams();
  return <React.Fragment key={params[param]}>{children}</React.Fragment>;
}
